/**
 * Text comparison table. Numbers inside are already checked by the resolver.
 */
import { renderDataTable } from './data-table.js';
import { resolvedOf } from './shape.js';

/**
 * @param {object} block
 * @param {{ onAsk?: Function }} [actions]
 * @returns {HTMLElement}
 */
export function renderCompare(block, actions) {
  const data = resolvedOf(block);
  const heads = Array.isArray(data.columns) ? data.columns.map(String) : [];
  const columns = [
    { key: 'dimension', label: 'Dimension', width: 'wide', wrap: true },
    { key: 'a', label: heads[0] || 'A', wrap: true },
    { key: 'b', label: heads[1] || 'B', wrap: true },
    { key: 'implication', label: 'Implication', width: 'wide', wrap: true },
  ];
  const rows = (Array.isArray(data.rows) ? data.rows : []).map((row) => ({
    dimension: row.dimension,
    a: row.a,
    b: row.b,
    implication: row.implication || '',
  }));
  return renderDataTable({
    type: 'compare',
    id: block && block.id,
    title: data.title || 'Compare',
    columns,
    rows,
    sortable: data.sortable === true,
    actions,
    askTitle: data.title || 'Compare',
  });
}
